// 自定义组件

function plugins(Vue) {
    Vue.component("uploadPlus", () => import("@/pages/components/uploadPlus"));
    Vue.component("selectGroupPlus", () => import("@/pages/components/selectPlusGroup"));
    Vue.component("selectUserPlus", () => import("@/pages/components/selectPlusUser"));
    Vue.component("selectCarPlus", () => import("@/pages/components/selectPlusCar"));
    Vue.component("selectDriverPlus", () => import("@/pages/components/selectPlusDriver"));
    Vue.component("selectPersonPlus", () => import("@/pages/components/selectPlusPerson"));
    Vue.component("formPlus", () => import("@/pages/components/form"));
    Vue.component("delPlus", () => import("@/pages/components/del"));
    Vue.component("detailsPlus", () => import("@/pages/components/details"));
    Vue.component("importPlus", () => import("@/pages/components/import"));
};

export default plugins;


// WEBPACK FOOTER //
// ./src/pages/components/components.js